import { DeviceCheckinFailure } from '../models/device-checkin-failure';
import { DeviceCheckinCompleted } from '../models/device-checkin-completed';
import { BroadcastChannels, BroadcastService } from 'app/utils/broadcastService';

export enum DeviceStatusRequest {
    // requests -> to signalR
    WatchDevice = 1,
    StopWatchingDevice = 2,
    Refresh = 3,
    // responses-> from signalR
    Status = 4,
    Error = 5,
    Completed = 6,
    Timeout = 7
}

export interface DeviceCheckinStatusMessage {
    deviceId?: string; // The ID the device to checkin/refresh
    deviceCheckinStatus?: DeviceIdToCheckinStateMap;
    data?: DeviceCheckinFailure | DeviceCheckinCompleted | string;
    request: DeviceStatusRequest;
}

export interface DeviceIdToCheckinStateMap {
    [deviceId: string]: Date;
}

export class CheckinStateBroadcastService extends BroadcastService<DeviceCheckinStatusMessage> {
    constructor() {
        super(BroadcastChannels.onDeviceCheckinStatusChanged);
    }
}
